var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7826 7.24763C15.9487 7.24763 16.0994 7.32013 16.2186 7.44263C16.3296 7.57346 16.3855 7.73596 16.3693 7.90762C16.3693 7.96429 15.9252 13.5809 15.6715 15.945C15.5127 17.3959 14.5774 18.2767 13.1745 18.3009C12.0958 18.325 11.0414 18.3334 10.0032 18.3334C8.90093 18.3334 7.82302 18.325 6.77672 18.3009C5.42082 18.2684 4.48474 17.3717 4.33399 15.945C4.07302 13.5726 3.63699 7.96429 3.62889 7.90762C3.62079 7.73596 3.6759 7.57346 3.78774 7.44263C3.89796 7.32013 4.05681 7.24763 4.22377 7.24763H15.7826ZM11.7206 1.66669C12.4573 1.66669 13.1154 2.18085 13.3059 2.91417L13.442 3.5225C13.5522 4.01833 13.9818 4.36916 14.4762 4.36916H16.9059C17.2301 4.36916 17.5 4.63832 17.5 4.98082V5.29748C17.5 5.63165 17.2301 5.90914 16.9059 5.90914H3.09488C2.76988 5.90914 2.5 5.63165 2.5 5.29748V4.98082C2.5 4.63832 2.76988 4.36916 3.09488 4.36916H5.52464C6.01821 4.36916 6.44775 4.01833 6.55879 3.52334L6.68603 2.95501C6.88378 2.18085 7.53458 1.66669 8.27939 1.66669H11.7206Z",
    fill: "#D90D0D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.15d10430.svg";
export { ForwardRef as ReactComponent };